{
  "version": 1,
  "asset_id": "f7a842d4-6ab7-41bb-84a9-78ea012c1570",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/f7a842d4-6ab7-41bb-84a9-78ea012c1570/warmtepompen-640.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/f7a842d4-6ab7-41bb-84a9-78ea012c1570/warmtepompen-640.avif",
  "original_filename": "warmtepompen-640.avif",
  "size": 16998,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:03:51Z"
}
